import { render, staticRenderFns } from "./MyLessonForm.vue?vue&type=template&id=70b0a60b"
import script from "./MyLessonForm.vue?vue&type=script&lang=js"
export * from "./MyLessonForm.vue?vue&type=script&lang=js"
import style0 from "./MyLessonForm.vue?vue&type=style&index=0&id=70b0a60b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports